<template>
  <v-navigation-drawer
    v-model="DRAWER_MENU"
    :width="325"
    absolute
    temporary
  >
    <v-btn
      icon
      @click="SET_DRAWER(false)"
      class="float-right mr-1 mt-2"
    >
      <v-icon class="icon-close">mdi-close</v-icon>
    </v-btn>

    <v-list no-action class="py-0">
      <v-list-item-content class="text-center pb-0">
        <img :src="empresa.logo" class="img-empresa" width="100" />
        <span class="titulo-nome">{{ usuario.nome }}</span>
        <span class="titulo-cargo">{{ usuario.setor }}</span>

        <div class="d-flex align-center w-full pt-2 pb-3">
          <v-switch v-model="permitir_tela_cheia" class="h-10px mt-n3" dense color="#a71830">
            <template #label>
              <span class="font-12 ml-1"> Permitir tela cheia </span>
            </template>
          </v-switch>

          <v-spacer />

          <span class="font-12 text-gray-800">Versão: {{ app_version }}</span>
        </div>
      </v-list-item-content>
    </v-list>

    <v-divider />

    <div
      style="max-height: calc(100vh - 243px); overflow-y: auto"
    >
      <v-list>
        <v-list-group
          v-for="item in ITEMS_DRAWER_MENU"
          :key="item.url"
          v-model="item.ativo"
          :prepend-icon="item.icone"
          :append-icon="item.items.length > 0 ? 'mdi-menu-down' : ''"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content v-if="item.items.length > 0">
              <v-list-item-title v-text="item.descricao" class="list-item" />
            </v-list-item-content>

            <v-list-item-content v-else @click="linkRota(item)">
              <v-list-item-title v-text="item.descricao" class="list-item" />
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in item.items"
            :key="subItem.id"
            @click="linkRota(subItem, item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="subItem.descricao" class="list-item" />
            </v-list-item-content>
          </v-list-item>

        </v-list-group>
      </v-list>
    </div>

    <v-divider />

    <v-list-item link>
      <v-list-item-content @click="abrirPaginaDeSuporte()">
        <v-list-item-title class="list-item-sair">
          <v-list-item-icon style="margin: 0 13% 0 0">
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-icon>
          Chat Suporte
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item link>
      <v-list-item-content>
        <v-list-item-title
          class="list-item-sair"
          @click="Helpers.logout()"
        >
          <v-list-item-icon style="margin: 0 13% 0 0">
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          Sair
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data: () => ({
    group: null,
    app_version: localStorage.getItem('app_version'),
    permitir_tela_cheia: localStorage.permitir_tela_cheia === "S" || !localStorage.permitir_tela_cheia
  }),
  computed: {
    ...mapState("app", ["empresa", "usuario"]),
    ...mapGetters({
      GET_DRAWER: "MenuParametrizacaoIncludes/GET_DRAWER",
      GET_ITEMS_DRAWER: "MenuParametrizacaoIncludes/GET_ITEMS_DRAWER",
    }),
    DRAWER_MENU: {
      get() { return this.GET_DRAWER; },
      set(val) { this.SET_DRAWER(val); },
    },
    ITEMS_DRAWER_MENU: {
      get() { return this.GET_ITEMS_DRAWER; },
      set(val) { this.SET_ITEMS_DRAWER(val); },
    },
  },
  watch: {
    permitir_tela_cheia() {
      localStorage.permitir_tela_cheia = this.permitir_tela_cheia ? "S" : "N"
    }
  },
  methods: {
    ...mapMutations({
      SET_DRAWER: "MenuParametrizacaoIncludes/SET_DRAWER",
      SET_ITEMS_DRAWER: "MenuParametrizacaoIncludes/SET_ITEMS_DRAWER",
    }),
    abrirPaginaDeSuporte() {
      window.open(localStorage.url_chat_bot, "_blank", "width=480, height=600")
    },
    linkRota(sub_item, item) {
      if (item) {
        this.$router.push(sub_item.url);
      } else {
        this.$router.push(sub_item.url);
      }
      this.SET_DRAWER(false);
    },
  }
}
</script>

<style scoped>
.img-empresa {
  padding: 0% 5% 0% 5%;
}
.titulo-nome {
  color: #042333;
  font-size: 20px;
}

.titulo-cargo {
  color: #042333;
  font-size: 16px;
}

.list-item {
  color: #042333;
  font-size: 14px;
  padding-left: 10px;
}

.list-item-sair {
  color: #042333;
  font-size: 14px;
}
</style>
